import classNames from 'classnames'
import React, { PropsWithChildren, forwardRef, useRef } from 'react'

import { Scrollbar } from '@ui/v2/Scrollbar/Scrollbar'

import styles from './List.module.scss'

export type ListProps = React.HTMLAttributes<HTMLDivElement>

export const List = forwardRef<HTMLDivElement, PropsWithChildren<ListProps>>(
  ({ children, ...props }, ref) => {
    const innerRef = useRef<HTMLDivElement | null>(null)

    const setRefs = (node: HTMLDivElement | null) => {
      innerRef.current = node
      if (typeof ref === 'function') ref(node)
      else if (ref) (ref as React.MutableRefObject<HTMLDivElement | null>).current = node
    }

    return (
      <div className={styles.listHost}>
        <div
          ref={setRefs}
          className={classNames(styles.list, 'custom-scrollbar-y-active')}
          {...props}
        >
          {children}
        </div>

        <Scrollbar parentRef={innerRef} orientation='vertical' size='sm' />
      </div>
    )
  }
)
